import MobileContainer from './MobileContainer';

export default MobileContainer;
